import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const hero = document.querySelector('.services-hero, .drive-hero');
  const heroClass = hero?.classList.contains('drive-hero')
    ? 'drive-hero'
    : 'services-hero';
  const container = hero?.querySelector(`.${heroClass}__container`);
  const wrapper = hero?.querySelector(`.${heroClass}__wrapper`);
  const menu = hero?.querySelector(`.${heroClass}__menu`);
  let servicesMenuDropdown = null;
  const servicesMenu = menu?.querySelector(
    '#menu-services-menu, .menu-services-menu, .services-menu'
  );
  const header = document.querySelector('header');
  const progressBar = document.querySelector('.services-details__progress-bar');
  const progressItems = progressBar
    ? [...progressBar.querySelectorAll('.progress-bar__item')]
    : [];
  const progressRow = progressBar?.querySelector('.progress-bar__row');
  const serviceAnchorItems = [
    ...document.querySelectorAll('.services-details__anchor'),
  ];
  const progressLines = progressBar
    ? [...progressBar.querySelectorAll('.progress-bar__line')]
    : [];
  const serviceItems = [
    ...document.querySelectorAll('.services-details__item'),
  ];
  const serviceSectionParam = 'service_section';

  if (!hero || !container || !wrapper || !menu) return;

  if (progressBar && progressBar.parentElement !== wrapper) {
    wrapper.appendChild(progressBar);
  }

  if (servicesMenu) {
    const activeMenuLink =
      servicesMenu.querySelector(
        '.current-menu-item > a, .current_page_item > a'
      ) || servicesMenu.querySelector('a');
    const dropdown = document.createElement('div');
    const dropdownToggle = document.createElement('button');
    const dropdownLabel = document.createElement('span');
    const dropdownList = document.createElement('ul');

    dropdown.className = `${heroClass}__menu-dropdown`;
    dropdownToggle.className = `${heroClass}__menu-dropdown-toggle`;
    dropdownToggle.type = 'button';
    dropdownToggle.setAttribute('aria-expanded', 'false');
    dropdownLabel.className = `${heroClass}__menu-dropdown-label`;
    dropdownLabel.textContent = activeMenuLink?.textContent?.trim() || '';
    dropdownList.className = `${heroClass}__menu-dropdown-list`;

    [...servicesMenu.querySelectorAll('li > a')]
      .filter((link) => link.parentElement?.parentElement === servicesMenu)
      .forEach((link) => {
        const dropdownItem = document.createElement('li');
        const dropdownLink = document.createElement('a');
        const parentItem = link.closest('li');

        dropdownLink.href = link.href;
        dropdownLink.textContent = link.textContent;
        dropdownLink.className = `${heroClass}__menu-dropdown-link`;

        if (
          parentItem?.classList.contains('current-menu-item') ||
          parentItem?.classList.contains('current_page_item')
        ) {
          dropdownLink.classList.add('is-active');
        }

        if (
          parentItem?.classList.contains('menu-item--extended-service-page')
        ) {
          dropdownLink.classList.add('is-extended-service-page');
        }

        dropdownLink.addEventListener('click', () => {
          dropdownLabel.textContent = dropdownLink.textContent.trim();
          dropdown.classList.remove('is-open');
          wrapper.classList.remove('dropdown-is-open');
          dropdownToggle.setAttribute('aria-expanded', 'false');
        });

        dropdownItem.appendChild(dropdownLink);
        dropdownList.appendChild(dropdownItem);
      });

    dropdownToggle.appendChild(dropdownLabel);
    dropdown.append(dropdownToggle, dropdownList);
    menu.insertBefore(dropdown, menu.firstChild);

    dropdownToggle.addEventListener('click', () => {
      const isOpen = dropdown.classList.toggle('is-open');

      wrapper.classList.toggle('dropdown-is-open', isOpen);
      dropdownToggle.setAttribute('aria-expanded', String(isOpen));
    });

    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('is-open');
        wrapper.classList.remove('dropdown-is-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        dropdown.classList.remove('is-open');
        wrapper.classList.remove('dropdown-is-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
      }
    });

    servicesMenuDropdown = dropdown;
  }

  const placeholder = document.createElement('div');
  placeholder.classList.add(
    'services-hero-placeholder',
    `${heroClass}-placeholder`
  );
  container.insertBefore(placeholder, wrapper);

  const remToPx = (rem) => {
    return (
      rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
    );
  };

  const getMenuAbsoluteTop = () => {
    const menuRect = menu.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return scrollTop + menuRect.top;
  };

  let menuTopPos,
    wrapperHeight,
    triggerHideHeader,
    triggerFixWrapper,
    triggerReleaseWrapper;
  let progressBarHeight = progressBar?.offsetHeight || 0;
  const anchorScrollGap = 64;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const getMenuHeight = () => {
    if (isCompactProgressBar() && servicesMenuDropdown) {
      return servicesMenuDropdown.offsetHeight || menu.offsetHeight || 0;
    }

    return servicesMenu?.offsetHeight || menu.offsetHeight || 0;
  };

  const getProgressBarHeight = () => {
    const progressBarRow = progressBar?.querySelector('.progress-bar__row');

    return progressBarRow?.offsetHeight || progressBar?.offsetHeight || 0;
  };

  const setFixedVisibleHeight = (includeProgressBar = false) => {
    const visibleHeight =
      getMenuHeight() + 32 + (includeProgressBar ? progressBarHeight : 0);

    wrapper.style.setProperty(
      '--services-fixed-visible-height',
      `${visibleHeight}px`
    );
  };

  const getFixedMenuBottom = () => {
    if (wrapper.classList.contains('is-fixed')) {
      const wrapperRect = wrapper.getBoundingClientRect();
      const visibleProgressHeight = progressBar?.classList.contains('is-fixed')
        ? progressBarHeight
        : 0;

      return wrapperRect.bottom - visibleProgressHeight;
    }

    if (header && !header.classList.contains('header-hidden')) {
      return header.getBoundingClientRect().bottom;
    }

    return 0;
  };

  const isCompactProgressBar = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  };

  const updateProgressTrackPosition = (activeItem = null) => {
    if (!progressRow) return;

    if (!isCompactProgressBar() || !activeItem) {
      progressRow.style.setProperty('--progress-track-offset', '0px');
      return;
    }

    const activeItemCenter = activeItem.offsetLeft + activeItem.offsetWidth / 2;
    const viewportCenter = window.innerWidth / 2;

    progressRow.style.setProperty(
      '--progress-track-offset',
      `${viewportCenter - activeItemCenter}px`
    );
  };

  const setActiveProgressItem = (activeId) => {
    let activeItem = null;

    progressItems.forEach((item) => {
      const isActive = item.dataset.serviceTarget === activeId;

      item.classList.toggle('is-active', isActive);

      if (isActive) {
        activeItem = item;
      }
    });

    updateProgressTrackPosition(activeItem);
  };

  const setLineProgress = (line, progress) => {
    line.style.setProperty('--line-progress', `${progress}%`);
  };

  const getHeaderHeight = () => {
    return header?.offsetHeight || 0;
  };

  const getAnchorOffset = (targetTop, scrollTop) => {
    const isScrollingToPreviousItem = targetTop < scrollTop;
    const headerOffset = isScrollingToPreviousItem ? getHeaderHeight() : 0;

    return getMenuHeight() + progressBarHeight + anchorScrollGap + headerOffset;
  };

  const normalizeServiceTitle = (title = '') => {
    if (typeof title !== 'string') return '';

    return title.replace(/\s+/g, ' ').trim().toLowerCase();
  };

  const getServiceItemTitle = (serviceItem) => {
    const title = serviceItem?.querySelector('.services-details__intro-title');

    if (!title) return '';

    const titleClone = title.cloneNode(true);

    titleClone
      .querySelectorAll('.services-details__intro-icon')
      .forEach((icon) => {
        icon.remove();
      });

    return titleClone.textContent?.trim() || '';
  };

  const getCurrentServiceItem = () => {
    if (!serviceItems.length) return null;

    const activationLine =
      getFixedMenuBottom() + progressBarHeight + anchorScrollGap;
    const firstItemRect = serviceItems[0].getBoundingClientRect();
    const lastItemRect =
      serviceItems[serviceItems.length - 1].getBoundingClientRect();

    if (
      firstItemRect.top > activationLine ||
      lastItemRect.bottom <= activationLine
    ) {
      return null;
    }

    return serviceItems.reduce((currentItem, serviceItem) => {
      const itemRect = serviceItem.getBoundingClientRect();

      if (itemRect.top <= activationLine) {
        return serviceItem;
      }

      return currentItem;
    }, serviceItems[0]);
  };

  const getServiceItemByTitle = (title) => {
    const normalizedTitle = normalizeServiceTitle(title);

    if (!normalizedTitle) return null;

    return serviceItems.find((serviceItem) => {
      return (
        normalizeServiceTitle(getServiceItemTitle(serviceItem)) ===
        normalizedTitle
      );
    });
  };

  const scrollToServiceItem = (targetId) => {
    const target = document.getElementById(targetId);

    if (!target) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetTop = target.getBoundingClientRect().top + scrollTop;
    const fixedOffset = getAnchorOffset(targetTop, scrollTop);

    window.scrollTo({
      top: Math.max(targetTop - fixedOffset, 0),
      behavior: 'smooth',
    });

    if (window.history.pushState) {
      window.history.pushState(null, '', `#${targetId}`);
    }
  };

  const scrollToServiceItemElement = (target, behavior = 'smooth') => {
    if (!target) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetTop = target.getBoundingClientRect().top + scrollTop;
    const fixedOffset = getAnchorOffset(targetTop, scrollTop);

    window.scrollTo({
      top: Math.max(targetTop - fixedOffset, 0),
      behavior,
    });
  };

  const updateServicesMenuLinkSectionParam = (link) => {
    const currentServiceItem = getCurrentServiceItem();
    const currentServiceTitle = getServiceItemTitle(currentServiceItem);

    if (!currentServiceTitle) return;

    const url = new URL(link.href, window.location.href);

    if (url.origin !== window.location.origin) return;

    url.searchParams.set(serviceSectionParam, currentServiceTitle);
    url.hash = '';
    link.href = url.toString();
  };

  const scrollToRequestedServiceSection = () => {
    const requestedServiceTitle = new URLSearchParams(
      window.location.search
    ).get(serviceSectionParam);
    const targetServiceItem = getServiceItemByTitle(requestedServiceTitle);

    if (!targetServiceItem) return;

    window.requestAnimationFrame(() => {
      updateMetrics();
      scrollToServiceItemElement(targetServiceItem, 'auto');
      handleScroll();
    });
  };

  const updateProgressBar = () => {
    if (!progressBar || !serviceItems.length) return;

    const isWrapperFixed = wrapper.classList.contains('is-fixed');
    const fixedTop = getFixedMenuBottom();
    const firstItemRect = serviceItems[0].getBoundingClientRect();
    const lastItemRect =
      serviceItems[serviceItems.length - 1].getBoundingClientRect();
    const activationLine = fixedTop + progressBarHeight;
    const shouldShow =
      isWrapperFixed &&
      firstItemRect.top <= fixedTop + progressBarHeight + anchorScrollGap &&
      lastItemRect.bottom > activationLine;

    progressBar.classList.toggle('is-fixed', shouldShow);
    setFixedVisibleHeight(shouldShow);

    if (!shouldShow) {
      progressLines.forEach((line) => {
        setLineProgress(line, firstItemRect.top > fixedTop ? 0 : 100);
      });
      setActiveProgressItem(null);
      return;
    }

    const segmentProgress = progressItems.map((progressItem, index) => {
      const serviceItem = document.getElementById(
        progressItem.dataset.serviceTarget
      );

      if (!serviceItem || index >= progressLines.length) return null;

      const itemRect = serviceItem.getBoundingClientRect();
      const itemProgress =
        ((activationLine - itemRect.top) / Math.max(itemRect.height, 1)) * 100;
      const progress = clamp(itemProgress, 0, 100);

      setLineProgress(progressLines[index], progress);

      return progress;
    });

    const activeIndex = segmentProgress.findIndex((progress) => {
      return progress !== null && progress < 100;
    });
    const activeProgressItem =
      activeIndex === -1
        ? progressItems[progressItems.length - 1]
        : progressItems[activeIndex];

    setActiveProgressItem(activeProgressItem?.dataset.serviceTarget || null);
  };

  const updateMetrics = () => {
    const isFixedNow = wrapper.classList.contains('is-fixed');
    const isProgressFixedNow = progressBar?.classList.contains('is-fixed');

    if (isFixedNow) {
      wrapper.classList.remove('is-fixed');
      placeholder.style.height = '0px';
      placeholder.style.display = 'none';
    }

    if (isProgressFixedNow) {
      progressBar.classList.remove('is-fixed');
    }

    menuTopPos = getMenuAbsoluteTop();
    wrapperHeight = wrapper.offsetHeight;
    triggerHideHeader = menuTopPos - remToPx(6.25);
    triggerFixWrapper = menuTopPos - remToPx(2);
    triggerReleaseWrapper = menuTopPos - remToPx(5.563);
    progressBarHeight = getProgressBarHeight();
    setFixedVisibleHeight(isProgressFixedNow);

    if (isFixedNow) {
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll >= triggerReleaseWrapper) {
        placeholder.style.height = `${wrapperHeight}px`;
        placeholder.style.display = 'block';
        wrapper.classList.add('is-fixed');
      }
    }

    if (isProgressFixedNow) {
      progressBar.classList.add('is-fixed');
    }

    updateProgressBar();
  };

  updateMetrics();
  let lastScroll = window.pageYOffset || document.documentElement.scrollTop;

  const handleScroll = () => {
    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;
    const isScrollingUp = currentScroll < lastScroll;

    if (!isScrollingUp) {
      if (currentScroll >= triggerFixWrapper) {
        if (!wrapper.classList.contains('is-fixed')) {
          placeholder.style.height = `${wrapperHeight}px`;
          placeholder.style.display = 'block';
          wrapper.classList.add('is-fixed');
        }
        if (header) {
          header.classList.add('header-hidden');
        }
      } else {
        if (header) {
          if (currentScroll >= triggerHideHeader) {
            header.classList.add('header-hidden');
          } else {
            header.classList.remove('header-hidden');
          }
        }
      }
    } else {
      if (currentScroll >= triggerReleaseWrapper) {
        if (!wrapper.classList.contains('is-fixed')) {
          placeholder.style.height = `${wrapperHeight}px`;
          placeholder.style.display = 'block';
          wrapper.classList.add('is-fixed');
        }
        if (header) {
          header.classList.remove('header-hidden');
        }
      } else {
        if (wrapper.classList.contains('is-fixed')) {
          wrapper.classList.remove('is-fixed');
          placeholder.style.height = '0px';
          placeholder.style.display = 'none';
        }
        if (header) {
          header.classList.remove('header-hidden');
        }
      }
    }

    if (wrapper.classList.contains('is-fixed')) {
      if (header) {
        header.classList.add('services-nav-active');
        if (!header.classList.contains('header-hidden')) {
          wrapper.classList.add('header-is-visible');
        } else {
          wrapper.classList.remove('header-is-visible');
        }
      }
    } else {
      wrapper.classList.remove('header-is-visible');
      if (header) {
        header.classList.remove('services-nav-active');
      }
    }

    updateProgressBar();

    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
  };

  let ticking = false;
  const requestScrollUpdate = () => {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(() => {
      handleScroll();
      ticking = false;
    });
  };

  window.addEventListener('resize', () => {
    updateMetrics();
    updateProgressTrackPosition(
      progressBar?.querySelector('.progress-bar__item.is-active')
    );
    requestScrollUpdate();
  });

  if (servicesMenu) {
    const servicesMenuLinks = [
      ...servicesMenu.querySelectorAll('a'),
      ...(servicesMenuDropdown
        ? [...servicesMenuDropdown.querySelectorAll('a')]
        : []),
    ];

    servicesMenuLinks.forEach((link) => {
      link.addEventListener('click', () => {
        updateServicesMenuLinkSectionParam(link);
      });
    });
  }

  [...progressItems, ...serviceAnchorItems].forEach((item) => {
    item.addEventListener('click', (event) => {
      const targetId =
        item.dataset.serviceTarget || item.getAttribute('href')?.split('#')[1];

      if (!targetId) return;

      event.preventDefault();
      scrollToServiceItem(targetId);
    });
  });
  window.addEventListener('scroll', requestScrollUpdate, { passive: true });
  handleScroll();
  scrollToRequestedServiceSection();
});
